import { clearTokens, saveTokens } from '@/lib/session-tokens';
import { queryClient } from '@/lib/query-client';
import { useAuthStore, type AuthenticatedUser } from '@/stores/auth-store';

/** Same-origin cookie sessions return a bare user; cross-site/mobile include tokens. */
export type SessionPayload =
  | AuthenticatedUser
  | {
      user: AuthenticatedUser;
      accessToken?: string;
      refreshToken?: string;
    };

export function extractUserFromSession(payload: SessionPayload): AuthenticatedUser {
  if ('user' in payload) {
    return payload.user;
  }
  return payload;
}

export function persistSessionTokens(payload: SessionPayload): void {
  if (
    'accessToken' in payload &&
    payload.accessToken &&
    'refreshToken' in payload &&
    payload.refreshToken
  ) {
    saveTokens(payload.accessToken, payload.refreshToken);
    return;
  }
  clearTokens();
}

export function adoptSession(
  payload: SessionPayload,
  options?: { invalidateQueries?: boolean },
): AuthenticatedUser {
  persistSessionTokens(payload);
  const user = extractUserFromSession(payload);
  useAuthStore.getState().setUser(user);
  if (options?.invalidateQueries !== false) {
    void queryClient.invalidateQueries();
  }
  return user;
}
